
import {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonSpinner,
    IonIcon,
    IonButton,
    IonInput,
    modalController,
    menuController,
    IonButtons,
} from "@ionic/vue";
import { add, refresh, menu } from "ionicons/icons";
import { QrStream } from "vue3-qr-reader";

import { ref, onMounted, computed } from "vue";

import { LOCALSTORAGE_KEY } from "@/custom_config";

import { openToast } from "@/services/toast";
import apiClienti from "@/services/clienti";
import apiProgetti from "@/services/progetti";

import ProjectDetail from "@/custom/components/ProjectDetail.vue";

export default {
    name: "Progetti",
    components: {
        IonHeader,
        IonToolbar,
        IonTitle,
        IonContent,
        IonPage,
        IonSpinner,
        IonIcon,
        IonButton,
        IonButtons,
        IonInput,
        QrStream,
    },
    setup() {
        const loading = ref(false);
        const userID = JSON.parse(localStorage.getItem(`${LOCALSTORAGE_KEY}`)).users_id;

        const openMenu = () => {
            menuController.open("app-menu");
        };

        const commesse = ref([]);
        const clienti = ref([]);
        const searchQuery = ref("");

        const filteredCommesse = computed(() => {
            const term = searchQuery.value.replace(/ /g, "");

            return commesse.value.filter((commessa) => {
                return (
                    commessa.projects_name
                        .toLowerCase()
                        .replace(/ /g, "")
                        .indexOf(term.toLowerCase().replace(/ /g, "")) != -1
                );
            });
        });

        /**
         * ! Limit customers to 30 charactes
         */
        function setShortName(name_commessa) {
            if (!name_commessa) {
                return "-";
            } else {
                const trimmedString = name_commessa.length > 30 ? name_commessa.substring(0, 27) + "..." : name_commessa;
                return trimmedString;
            }
        }

        const riferimentoCliente = (cliente) => {
            if (cliente.customers_company) {
                return cliente.customers_company;
            } else if (cliente.customers_name && !cliente.customers_last_name) {
                return `${cliente.customers_name}`;
            } else if (!cliente.customers_name && cliente.customers_last_name) {
                return `${cliente.customers_last_name}`;
            } else if (cliente.customers_name && cliente.customers_last_name) {
                return `${cliente.customers_name} ${cliente.customers_last_name}`;
            }
            return ``;
        };

        /**
         * Badge stato progetto
         */
        const commessaStatus = computed(() => {
            return (statusId) => {
                let className = "";
                if (statusId == 1) {
                    //da schedulare
                    className = "badge_open";
                } else if (statusId == 2) {
                    //in corso
                    className = "badge_in_progress";
                } else if (statusId == 3) {
                    //in pausa
                    className = "badge_pause";
                } else if (statusId == 4) {
                    //cancellato
                    className = "badge_canceled";
                } else if (statusId == 5) {
                    //completato
                    className = "badge_completed";
                }
                return className;
            };
        });

        /**
         * Open project detail page
         */
        async function openProject(commessa) {
            const modal = await modalController.create({
                component: ProjectDetail,
                componentProps: {
                    data: commessa,
                },
            });
            return modal.present();
        }

        /**
         * Get all clienti
         */
        async function loadClienti() {
            loading.value = true;
            try {
                const res = await apiClienti.getCustomers();
                if (res.status === 0) {
                    clienti.value = res.data;
                } else {
                    openToast("Errore durante la richiesta dei clienti", "toast_danger");
                }
            } catch (error) {
                clienti.value = [];
                openToast("Errore durante la richiesta dei clienti", "toast_danger");
            } finally {
                loading.value = false;
            }
        }

        async function loadCommesse() {
            loading.value = true;
            try {
                const res = await apiProgetti.getCommesse();
                if (res.status === 0) {
                    commesse.value = res.data;
                } else {
                    openToast("Si è verificato un errore durante la richiesta delle commesse", "toast_danger");
                }
            } catch (error) {
                clienti.value = [];
                openToast("Si è verificato un errore durante la richiesta delle commesse", "toast_danger");
            } finally {
                loading.value = false;
            }
        }

        /**
         * ! QR Code Scanner Logic
         */
        const showQrScanner = ref(false);
        const scanResult = ref("");
        const isScanning = ref(false);

        function scanCommessaQR() {
            showQrScanner.value = true;
            scanResult.value = "";
        }

        function closeQrScanner() {
            showQrScanner.value = false;
            scanResult.value = "";
            isScanning.value = false;
        }

        async function onQrDecode(decodedText) {
            if (isScanning.value) return; // Prevent multiple scans
            
            isScanning.value = true;

            if(decodedText && decodedText !== "") {
                scanResult.value = `Scansionato: ${decodedText}`;
                try {
                    // Call API to get commessa details by QR code
                    const response = await apiProgetti.scanCommessaQR(decodedText);
                    
                    if (response.status === 200 && response.data.status === 0 && response.data.data.length > 0) {
                        openToast("Commessa trovata", "toast_success");
                        closeQrScanner();
                        // Open project detail modal
                        await openProject(response.data.data[0]);
                    } else {
                        openToast("Nessuna commessa associata a questo QR code", "toast_danger");
                        setTimeout(() => {
                            isScanning.value = false;
                            scanResult.value = "";
                        }, 2000);
                    }
                } catch (error) {
                    console.error("Error scanning QR:", error);
                    openToast("Si è verificato un errore durante la scansione del QR code", "toast_danger");
                    setTimeout(() => {
                        isScanning.value = false;
                        scanResult.value = "";
                    }, 2000);
                }
            } else {
                // QR vuoto o non valido
                setTimeout(() => {
                    isScanning.value = false;
                    scanResult.value = "";
                }, 1000);
            }
        }

        onMounted(() => {
            //GET CLIENTI DATA
            loadClienti();
            loadCommesse();
        });

        return {
            loading,
            add,
            refresh,
            openProject,
            loadClienti,
            clienti,
            searchQuery,
            filteredCommesse,
            riferimentoCliente,
            menu,
            openMenu,
            //progetti
            commesse,
            loadCommesse,
            commessaStatus,
            setShortName,
            // QR Scanner
            showQrScanner,
            scanResult,
            isScanning,
            scanCommessaQR,
            closeQrScanner,
            onQrDecode,
        };
    },
};
